import{error as t}from"./error.mjs";async function r(r,{id:e,type:i}){try{const t=r.filter(t=>t.id===e&&t.type===i)[0]||{id:e,type:i};return Object.assign({},t)}catch(r){t(r)}}export{r as filterIncludes};
